export const BLOCKED_FILE_EXTENSIONS = [
  'exe', 'msi', 'msp', 'msix', 'appx', 'appxbundle',
  'bat', 'cmd', 'com', 'scr', 'pif',
  'vbs', 'vbe', 'wsf', 'wsh',
  'ps1', 'psm1', 'psd1', 'ps1xml',
  'dll', 'sys', 'hta', 'jar',
  'reg', 'lnk', 'cpl', 'inf', 'msc',
  'app', 'deb', 'rpm', 'dmg',
  'application', 'gadget', 'diagcab',
];

export const BLOCKED_EXTENSIONS = new Set(BLOCKED_FILE_EXTENSIONS);

export const FC_DRAG_DROP_FILE_ACCEPT = '.xlsx,.xls,.xlsm,.xlsb,.doc,.docx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.svg,.mp4,.csv';

export const FC_DRAG_DROP_FILE_DEFAULT_TITLE = 'Drop a file or click to browse';

export const FC_DRAG_DROP_FILE_DEFAULT_HINT = 'PDF, XLSX, DOCX · up to 25 MB';

export const FC_DRAG_DROP_FILE_DRAGGING_TITLE = 'Release to drop files here';
